import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { List as ListComponent, useDrawer, DrawerButton } from 'src/mtska-frontend-app-component';
import { useGridApiRef } from '@mui/x-data-grid';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import ImportButton from '../../Import/components/ImportButton';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadAll } from 'src/mtska-frontend-data-provider/hooks/useLoadAll.hooks';

const dataProviderName = 'zoho/order';
const drawerRouteBase = 'zohoorders';

const moduleName = "Zoho Orders";

const List = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);
    const { activate } = useDrawer();

    const apiRef = useGridApiRef();
    const getSelected = () => {
        return [...apiRef.current.getSelectedRows()].map(([name]) => name);
    };
    const [selected, setSelected] = useState([]);
    const handleRowSelection = (newSelection) => {
        setSelected(newSelection);
        params.rowSelectionExternalListener && params.rowSelectionExternalListener(newSelection);
    };



    const { doAction, loadAll, items, total, loading, reloadCounter } = useDataProvider(dataProviderName);
    const [listFilterPageSort, setListFilterPageSort] = useState();
    const handleFilterPageSortChange = (model) => {
        setListFilterPageSort(model);
    }

    useLoadAll({ listFilterPageSort, loadAll, params, reloadCounter })

    const handleRowDoubleclick = (row) => {
        activate(drawerRouteBase + '/detail', { id: row.id });
    }

    return (
        <>
            {userCapabilities && userCapabilities[dataProviderName + '.list'] && (
                <>
                    <ListComponent
                        {...params}
                        onRowDoubleClick={(userCapabilities && userCapabilities[dataProviderName + '.view']) ? handleRowDoubleclick : () => { }}
                        onFilterPageSortChange={handleFilterPageSortChange}
                        items={items}
                        total={total}
                        loading={loading}
                        apiRef={apiRef}
                        enableSelection
                        rightButtons={[
                            <DrawerButton
                                drawerRoute={drawerRouteBase + '/applyAction'}
                                className="button-new"
                                params={{
                                    items: selected,
                                    dataProviderName: dataProviderName
                                }}
                                label={t("Apply action")}
                            // disabled={userCapabilities && !userCapabilities[dataProviderName + '.create']}
                            />,
                            // <ImportButton // import
                            //     dataProviderName={dataProviderName}
                            //     callback={(data) => {
                            //         loadAll();
                            //     }}
                            //     disabled={userCapabilities && !userCapabilities[dataProviderName + '.import']}
                            // />,

                        ]}
                        dataProviderName={dataProviderName}
                        title={moduleName}
                        rowSelectionExternalListener={handleRowSelection}
                        doAction={doAction}
                        // rowGrouping='zohoOrderId' TO BE KILLED IF OK
                        treeData
                        treeDataDrawerRoutes={{ 'inspect': 'cars/detail', 'choose': 'ordermanagement/detail', 'contract': 'contracts/detail' }}
                    />
                </>
            )}
        </>
    );
};

export default List;


